//#region src/services/dataStreamManager/IDataStreamManagerService.ts
const DATASTREAM_MANAGER_SERVICE_IDENT = "org.aimystic.service.DataStreamManager";
const RPC_EVENT_STREAM_STATE_CHANGED_IDENT = "org.aimystic.events.dataStreamManager.streamStateChanged";
const RPC_EVENT_STREAM_STATE_CHANGED = {
	ident: RPC_EVENT_STREAM_STATE_CHANGED_IDENT,
	description: "Event emitted when stream state changes (running, feedback updates)",
	groups: ["stream"],
	params: [{
		name: "streamId",
		type: "string",
		description: "The ID of the stream"
	}, {
		name: "state",
		type: "object",
		description: "The current stream state"
	}]
};
/**
* Approximate token counter using character-based estimation
* Conservative estimate: 1 token ≈ 3.5 characters.
* Intentionally over-counts so fetchHistory returns fewer entries than the
* actual token limit — the provider's real tokenizer is the source of truth.
* Using 3.5 instead of 4 accounts for code/JSON content where tokens are shorter.
*/
function approximateTokenCounter(entry) {
	const json = JSON.stringify(entry);
	return Math.ceil(json.length / 3.5);
}

//#endregion
export { DATASTREAM_MANAGER_SERVICE_IDENT, RPC_EVENT_STREAM_STATE_CHANGED, RPC_EVENT_STREAM_STATE_CHANGED_IDENT, approximateTokenCounter };
//# sourceMappingURL=IDataStreamManagerService.js.map